import {
  MillwrightWorkedHours,
  MillwrightWorkedHoursApiResponse,
} from '@/apis/workedHours/types/workedHours';

export const millwrightWorkedHoursFromApiAdapter = (
  workedHours: MillwrightWorkedHoursApiResponse,
): MillwrightWorkedHours => {
  return {
    empID: workedHours.EmpID ?? null,
    outageID: workedHours.OutageID ?? null,
    dateWorked: workedHours.DateWorked ?? '',
    rt_sum_6m: workedHours.RT_sum_6m ?? null,
    dt_sum_6m: workedHours.DT_sum_6m ?? null,
    ot_sum_6m: workedHours.OT_sum_6m ?? null,
    riskScore: workedHours.RiskScore ?? null,
  };
};
